import { FC, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../Hooks/Auth';
import { useToast } from '../../Hooks/ToasContext';
import api from '../../Services/api';
import { resetPasswordResetNotification } from '../../Services/password-reset-handler';import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service';
import { ChangeCollaboratorPasswordUseCase } from '../../Usecase/Collaborators/change-collaborator-password-usecas';
import { DialogChangePassword } from '../Dialog/variants/dialog-change-password';

const changePasswordUseCase = new ChangeCollaboratorPasswordUseCase(
  new CollaboratorsApiRemoteService(api),
);

export const ForcePasswordReset: FC = () => {
  const { user, updateUser, isAuthenticated, markPasswordResetRequired } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const mustReset = Boolean(isAuthenticated && user?.resetPassword);

  useEffect(() => {
    if (searchParams.get('resetPassword')) {
      markPasswordResetRequired();
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams, markPasswordResetRequired]);

  const handleConfirm = async (data: { password: string }) => {
    if (!user) {
      return;
    }

    setLoading(true);

    try {
      await changePasswordUseCase.handle(data.password);
      updateUser({ ...user, resetPassword: false });
      resetPasswordResetNotification();
      showToast('Senha definida com sucesso. Bem-vindo!', 'success');
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.error(error);
      showToast('Não foi possível alterar a senha. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!mustReset) {
    return null;
  }

  return (
    <DialogChangePassword
      open
      forceReset
      isLoading={loading}
      title="Primeiro acesso"
      description="Por segurança, defina uma nova senha antes de continuar. Ela deve ter no mínimo 6 caracteres, uma letra maiúscula e um caractere especial."
      onConfirm={handleConfirm}
      onCancel={() => {}}
    />
  );
};
